module.exports = __webpack_public_path__ + "static/media/CircleOutline.6a9e6a22.svg";